module.exports = __webpack_public_path__ + "static/media/user.8c08a809.png";